import React, { useState } from 'react';
import { IconButton, Popover, Text, Icon } from '@oneaudi/unified-web-components';
import { DangerousElement } from '../../../../../components';
export const InfoIcon = ({ hideButton, label, alignment, popupContent, iconSize, ariaLabel, }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (React.createElement("div", { "aria-hidden": hideButton, style: { visibility: hideButton ? 'hidden' : 'visible' } },
        React.createElement(Popover, { alignment: alignment, content: React.createElement("div", { style: {
                    alignItems: 'flex-start',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 24,
                    maxWidth: '480px',
                    maxHeight: '43vh',
                    overflowY: 'scroll',
                } },
                React.createElement(Text, { tag: "p", variant: { order: '1', style: 'normal', type: 'copy' } },
                    React.createElement(DangerousElement, { html: popupContent }))), "data-testid": `${label}-info-icon`, id: `${label}-info-icon-id`, onClose: () => {
                setIsOpen(false);
            }, open: isOpen, triggerElement: iconSize === 'sm' ? (React.createElement("button", { type: "button", onClick: () => {
                    setIsOpen(!isOpen);
                }, "aria-label": ariaLabel || label, style: { all: 'unset', cursor: 'pointer' } },
                React.createElement(Icon, { name: "info-circle", size: "xs" }))) : (React.createElement(IconButton, { icon: "info-circle", "aria-label": ariaLabel || label, variant: "tertiary", size: iconSize, onClick: () => {
                    setIsOpen(!isOpen);
                } })), withTip: true })));
};
